import React, { useState, useEffect } from 'react';
import { sms as smsApi } from '../services/sms';

export default function ConfigSMS() {
  const [concessions, setConcessions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [editModal, setEditModal] = useState(null); // concession en cours d'édition
  const [form, setForm] = useState({});
  const [saving, setSaving] = useState(false);
  const [msg, setMsg] = useState(null);

  const loadConfig = async () => {
    try {
      const res = await smsApi.getConfig();
      setConcessions(res.data.concessions || []);
    } catch (e) {
      setMsg({ type: 'err', text: e.response?.data?.error || 'Erreur de chargement' });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { loadConfig(); }, []);

  const openEdit = (c) => {
    setForm({
      sms_base_url: c.sms_base_url || '',
      sms_mb_soc: c.sms_mb_soc || '',
      sms_mb_use: c.sms_mb_use || '',
      sms_mb_pwd: '',
      sms_actif: c.sms_actif || false,
    });
    setEditModal(c);
    setMsg(null);
  };

  const handleSave = async () => {
    setSaving(true);
    setMsg(null);
    try {
      await smsApi.updateConfig(editModal.id, form);
      setEditModal(null);
      await loadConfig();
      setMsg({ type: 'ok', text: 'Configuration enregistrée.' });
      setTimeout(() => setMsg(null), 3000);
    } catch (e) {
      setMsg({ type: 'err', text: e.response?.data?.error || 'Erreur lors de la sauvegarde' });
    } finally {
      setSaving(false);
    }
  };

  if (loading) return <div style={{ padding: '40px', textAlign: 'center', color: 'var(--text-muted)' }}>Chargement…</div>;

  return (
    <div>
      <h2 style={{ fontSize: '18px', fontWeight: 700, marginBottom: '4px' }}>📱 Configuration SMS</h2>
      <p style={{ color: 'var(--text-secondary)', fontSize: '14px', marginBottom: '20px' }}>
        Configurez les paramètres d'envoi SMS (fournisseur Mobbiz) pour chaque concession.
      </p>

      {msg && !editModal && (
        <div style={{
          padding: '10px 16px', borderRadius: '8px', marginBottom: '16px', fontSize: '14px',
          background: msg.type === 'ok' ? '#f0fdf4' : '#fef2f2',
          color: msg.type === 'ok' ? 'var(--color-success)' : 'var(--color-error)',
          border: `1px solid ${msg.type === 'ok' ? '#bbf7d0' : '#fecaca'}`,
        }}>
          {msg.text}
        </div>
      )}

      <div className="table-container">
        <table className="table">
          <thead>
            <tr>
              <th>Concession</th>
              <th>URL de base</th>
              <th>Société (MBSOC)</th>
              <th>User (MBUSE)</th>
              <th>Mot de passe</th>
              <th>Actif</th>
              <th style={{ width: '80px' }}>Actions</th>
            </tr>
          </thead>
          <tbody>
            {concessions.map(c => (
              <tr key={c.id}>
                <td style={{ fontWeight: 600 }}>{c.nom}</td>
                <td style={{ fontSize: '13px', maxWidth: '250px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                  {c.sms_base_url || <span style={{ color: 'var(--text-muted)' }}>—</span>}
                </td>
                <td>{c.sms_mb_soc || <span style={{ color: 'var(--text-muted)' }}>—</span>}</td>
                <td>{c.sms_mb_use || <span style={{ color: 'var(--text-muted)' }}>—</span>}</td>
                <td>
                  <span style={{
                    fontSize: '12px', fontWeight: 600,
                    color: c.sms_pwd_set ? 'var(--color-success)' : 'var(--text-muted)',
                  }}>
                    {c.sms_pwd_set ? '✓ Configuré' : '—'}
                  </span>
                </td>
                <td>
                  <span style={{
                    display: 'inline-block', padding: '2px 10px', borderRadius: '12px', fontSize: '12px', fontWeight: 600,
                    background: c.sms_actif ? '#dcfce7' : 'var(--bg-muted)', color: c.sms_actif ? 'var(--color-success)' : 'var(--text-muted)',
                  }}>
                    {c.sms_actif ? 'Oui' : 'Non'}
                  </span>
                </td>
                <td>
                  <button onClick={() => openEdit(c)} className="btn-icon" title="Modifier la config SMS">✏️</button>
                </td>
              </tr>
            ))}
            {concessions.length === 0 && (
              <tr><td colSpan={7} style={{ textAlign: 'center', color: 'var(--text-muted)', padding: '30px' }}>Aucune concession</td></tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Modale d'édition */}
      {editModal && (
        <div className="modal-overlay">
          <div className="modal-content" onClick={e => e.stopPropagation()} style={{ maxWidth: '520px' }}>
            <h3 style={{ margin: '0 0 20px', fontSize: '16px', fontWeight: 700 }}>
              📱 Config SMS — {editModal.nom}
            </h3>

            {msg && (
              <div style={{
                padding: '10px 16px', borderRadius: '8px', marginBottom: '16px', fontSize: '14px',
                background: msg.type === 'ok' ? '#f0fdf4' : '#fef2f2',
                color: msg.type === 'ok' ? 'var(--color-success)' : 'var(--color-error)',
                border: `1px solid ${msg.type === 'ok' ? '#bbf7d0' : '#fecaca'}`,
              }}>
                {msg.text}
              </div>
            )}

            <div style={{ display: 'flex', flexDirection: 'column', gap: '14px' }}>
              <label style={{ fontSize: '13px', fontWeight: 600 }}>
                URL de base
                <input
                  type="text"
                  value={form.sms_base_url}
                  onChange={e => setForm({ ...form, sms_base_url: e.target.value })}
                  placeholder="http://www.mobbiz.fr/log/soguava.php"
                  style={{ display: 'block', width: '100%', marginTop: '4px', padding: '8px 12px', borderRadius: '8px', border: '1px solid #e2e8f0', fontSize: '14px', boxSizing: 'border-box' }}
                />
              </label>

              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '12px' }}>
                <label style={{ fontSize: '13px', fontWeight: 600 }}>
                  Société (MBSOC)
                  <input
                    type="text"
                    value={form.sms_mb_soc}
                    onChange={e => setForm({ ...form, sms_mb_soc: e.target.value })}
                    placeholder="9"
                    style={{ display: 'block', width: '100%', marginTop: '4px', padding: '8px 12px', borderRadius: '8px', border: '1px solid #e2e8f0', fontSize: '14px', boxSizing: 'border-box' }}
                  />
                </label>
                <label style={{ fontSize: '13px', fontWeight: 600 }}>
                  User (MBUSE)
                  <input
                    type="text"
                    value={form.sms_mb_use}
                    onChange={e => setForm({ ...form, sms_mb_use: e.target.value })}
                    placeholder="435"
                    style={{ display: 'block', width: '100%', marginTop: '4px', padding: '8px 12px', borderRadius: '8px', border: '1px solid #e2e8f0', fontSize: '14px', boxSizing: 'border-box' }}
                  />
                </label>
                <label style={{ fontSize: '13px', fontWeight: 600 }}>
                  Mot de passe (MBPWD)
                  <input
                    type="password"
                    value={form.sms_mb_pwd}
                    onChange={e => setForm({ ...form, sms_mb_pwd: e.target.value })}
                    placeholder="Laisser vide pour ne pas modifier"
                    style={{ display: 'block', width: '100%', marginTop: '4px', padding: '8px 12px', borderRadius: '8px', border: '1px solid #e2e8f0', fontSize: '14px', boxSizing: 'border-box' }}
                  />
                </label>
              </div>

              <label style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '14px', fontWeight: 600, cursor: 'pointer' }}>
                <input
                  type="checkbox"
                  checked={form.sms_actif}
                  onChange={e => setForm({ ...form, sms_actif: e.target.checked })}
                  style={{ width: '18px', height: '18px', accentColor: 'var(--color-success)' }}
                />
                Activer l'envoi SMS pour cette concession
              </label>
            </div>

            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px', marginTop: '24px' }}>
              <button
                onClick={() => setEditModal(null)}
                className="btn-secondary"
              >
                Annuler
              </button>
              <button
                onClick={handleSave}
                disabled={saving}
                className="btn-primary"
              >
                {saving ? 'Enregistrement…' : 'Enregistrer'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
